// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type EventInviteesQueryVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
  filters?: PrivateSchemaTypes.Maybe<Array<PrivateSchemaTypes.EventInviteeFilterInput> | PrivateSchemaTypes.EventInviteeFilterInput>;
  limit?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['PositiveInt']>;
  offset?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['NonNegativeInt']>;
  orderBy?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.InviteesIndirectOrderColumnEnum>;
  orderDirection: PrivateSchemaTypes.SqlOrderDirectionEnum;
}>;


export type EventInviteesQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { event?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'EventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.EventModelAsAdmin, 'id' | 'eventInviteesTotalCount'>
      & { eventInvitees: Array<(
        { __typename?: 'EventInvitee' }
        & InviteeItemFragment
      )> }
    )> }
  )> }
);

export type RecurringEventInviteesQueryVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
  filters?: PrivateSchemaTypes.Maybe<Array<PrivateSchemaTypes.EventInviteeFilterInput> | PrivateSchemaTypes.EventInviteeFilterInput>;
  limit?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['PositiveInt']>;
  offset?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['NonNegativeInt']>;
  orderBy?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.InviteesIndirectOrderColumnEnum>;
  orderDirection: PrivateSchemaTypes.SqlOrderDirectionEnum;
}>;


export type RecurringEventInviteesQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { recurringEvent?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'RecurringEventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.RecurringEventModelAsAdmin, 'id' | 'recurringEventInviteesTotalCount'>
      & { recurringEventInvitees: Array<(
        { __typename?: 'EventInvitee' }
        & InviteeItemFragment
      )> }
    )> }
  )> }
);

export type InviteeItemFragment = (
  { __typename?: 'EventInvitee' }
  & Pick<PrivateSchemaTypes.EventInvitee, 'attending' | 'present' | 'last_edit_by' | 'certification_id' | 'certification_name' | 'event_id' | 'user_id' | 'email' | 'display_name' | 'first_name' | 'last_name' | 'profile_img_url' | 'uploaded_img_url' | 'created_at' | 'account_name' | 'group_id' | 'group_name'>
);

export type ExportEventInviteesQueryVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
  filters?: PrivateSchemaTypes.Maybe<Array<PrivateSchemaTypes.UserEventModelWithSourceFilterInput> | PrivateSchemaTypes.UserEventModelWithSourceFilterInput>;
}>;


export type ExportEventInviteesQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { event?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'EventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.EventModelAsAdmin, 'id'>
      & { inviteesIncludingIndirect?: PrivateSchemaTypes.Maybe<(
        { __typename?: 'PaginatableInvitees' }
        & Pick<PrivateSchemaTypes.PaginatableInvitees, 'totalCount'>
        & { items: Array<(
          { __typename?: 'UserEventModelWithSource' }
          & Pick<PrivateSchemaTypes.UserEventModelWithSource, 'id' | 'present' | 'created_at' | 'attending'>
          & { user: (
            { __typename?: 'UserModel' }
            & Pick<PrivateSchemaTypes.UserModel, 'email' | 'display_name' | 'first_name' | 'last_name' | 'organisation_role'>
          ) }
        )> }
      )> }
    )> }
  )> }
);

export type RecurringExportEventInviteesQueryVariables = PrivateSchemaTypes.Exact<{
  eventId: PrivateSchemaTypes.Scalars['PositiveInt'];
  filters?: PrivateSchemaTypes.Maybe<Array<PrivateSchemaTypes.RecurringEventInviteeWithSourceFilterInput> | PrivateSchemaTypes.RecurringEventInviteeWithSourceFilterInput>;
}>;


export type RecurringExportEventInviteesQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { recurringEvent?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'RecurringEventModelAsAdmin' }
      & Pick<PrivateSchemaTypes.RecurringEventModelAsAdmin, 'id'>
      & { exportInviteesIncludingIndirect: (
        { __typename?: 'RecurringEventInviteesExportWithPagination' }
        & Pick<PrivateSchemaTypes.RecurringEventInviteesExportWithPagination, 'totalCount'>
        & { items: Array<(
          { __typename?: 'RecurringEventInviteeExport' }
          & Pick<PrivateSchemaTypes.RecurringEventInviteeExport, 'series_id' | 'attendance_type' | 'number_of_occurences' | 'created_by' | 'event_id' | 'event_title' | 'start_time' | 'end_time' | 'facilitator' | 'rsvp' | 'attendance' | 'created_at'>
          & { user?: PrivateSchemaTypes.Maybe<(
            { __typename?: 'UserModel' }
            & Pick<PrivateSchemaTypes.UserModel, 'email' | 'display_name' | 'first_name' | 'last_name' | 'organisation_role'>
          )> }
        )> }
      ) }
    )> }
  )> }
);

export const InviteeItemFragmentDoc = gql`
    fragment inviteeItem on EventInvitee {
  attending
  present
  last_edit_by
  certification_id
  certification_name
  event_id
  user_id
  email
  display_name
  first_name
  last_name
  profile_img_url
  uploaded_img_url
  created_at
  account_name
  group_id
  group_name
}
    `;
export const EventInviteesDocument = gql`
    query eventInvitees($eventId: PositiveInt!, $filters: [EventInviteeFilterInput!], $limit: PositiveInt, $offset: NonNegativeInt, $orderBy: InviteesIndirectOrderColumnEnum, $orderDirection: SQLOrderDirectionEnum!) {
  admin {
    event(id: $eventId) {
      id
      eventInviteesTotalCount(filters: $filters)
      eventInvitees(
        filters: $filters
        limit: $limit
        offset: $offset
        orderBy: $orderBy
        orderDirection: $orderDirection
      ) {
        ...inviteeItem
      }
    }
  }
}
    ${InviteeItemFragmentDoc}`;

/**
 * __useEventInviteesQuery__
 *
 * To run a query within a React component, call `useEventInviteesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventInviteesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventInviteesQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      orderDirection: // value for 'orderDirection'
 *   },
 * });
 */
export function useEventInviteesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EventInviteesQuery, EventInviteesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EventInviteesQuery, EventInviteesQueryVariables>(EventInviteesDocument, options);
      }
export function useEventInviteesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EventInviteesQuery, EventInviteesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EventInviteesQuery, EventInviteesQueryVariables>(EventInviteesDocument, options);
        }
export type EventInviteesQueryHookResult = ReturnType<typeof useEventInviteesQuery>;
export type EventInviteesLazyQueryHookResult = ReturnType<typeof useEventInviteesLazyQuery>;
export type EventInviteesQueryResult = Apollo.QueryResult<EventInviteesQuery, EventInviteesQueryVariables>;
export const RecurringEventInviteesDocument = gql`
    query recurringEventInvitees($eventId: PositiveInt!, $filters: [EventInviteeFilterInput!], $limit: PositiveInt, $offset: NonNegativeInt, $orderBy: InviteesIndirectOrderColumnEnum, $orderDirection: SQLOrderDirectionEnum!) {
  admin {
    recurringEvent(id: $eventId) {
      id
      recurringEventInviteesTotalCount(filters: $filters)
      recurringEventInvitees(
        filters: $filters
        limit: $limit
        offset: $offset
        orderBy: $orderBy
        orderDirection: $orderDirection
      ) {
        ...inviteeItem
      }
    }
  }
}
    ${InviteeItemFragmentDoc}`;

/**
 * __useRecurringEventInviteesQuery__
 *
 * To run a query within a React component, call `useRecurringEventInviteesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecurringEventInviteesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecurringEventInviteesQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      filters: // value for 'filters'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *      orderDirection: // value for 'orderDirection'
 *   },
 * });
 */
export function useRecurringEventInviteesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RecurringEventInviteesQuery, RecurringEventInviteesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RecurringEventInviteesQuery, RecurringEventInviteesQueryVariables>(RecurringEventInviteesDocument, options);
      }
export function useRecurringEventInviteesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RecurringEventInviteesQuery, RecurringEventInviteesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RecurringEventInviteesQuery, RecurringEventInviteesQueryVariables>(RecurringEventInviteesDocument, options);
        }
export type RecurringEventInviteesQueryHookResult = ReturnType<typeof useRecurringEventInviteesQuery>;
export type RecurringEventInviteesLazyQueryHookResult = ReturnType<typeof useRecurringEventInviteesLazyQuery>;
export type RecurringEventInviteesQueryResult = Apollo.QueryResult<RecurringEventInviteesQuery, RecurringEventInviteesQueryVariables>;
export const ExportEventInviteesDocument = gql`
    query exportEventInvitees($eventId: PositiveInt!, $filters: [UserEventModelWithSourceFilterInput!]) {
  admin {
    event(id: $eventId) {
      id
      inviteesIncludingIndirect {
        totalCount
        items(filters: $filters, orderDirection: ASC) {
          id
          present
          user {
            email
            display_name
            first_name
            last_name
            organisation_role
          }
          created_at
          attending
        }
      }
    }
  }
}
    `;

/**
 * __useExportEventInviteesQuery__
 *
 * To run a query within a React component, call `useExportEventInviteesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportEventInviteesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportEventInviteesQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useExportEventInviteesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ExportEventInviteesQuery, ExportEventInviteesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExportEventInviteesQuery, ExportEventInviteesQueryVariables>(ExportEventInviteesDocument, options);
      }
export function useExportEventInviteesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExportEventInviteesQuery, ExportEventInviteesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExportEventInviteesQuery, ExportEventInviteesQueryVariables>(ExportEventInviteesDocument, options);
        }
export type ExportEventInviteesQueryHookResult = ReturnType<typeof useExportEventInviteesQuery>;
export type ExportEventInviteesLazyQueryHookResult = ReturnType<typeof useExportEventInviteesLazyQuery>;
export type ExportEventInviteesQueryResult = Apollo.QueryResult<ExportEventInviteesQuery, ExportEventInviteesQueryVariables>;
export const RecurringExportEventInviteesDocument = gql`
    query recurringExportEventInvitees($eventId: PositiveInt!, $filters: [RecurringEventInviteeWithSourceFilterInput!]) {
  admin {
    recurringEvent(id: $eventId) {
      id
      exportInviteesIncludingIndirect {
        totalCount
        items(filters: $filters, orderDirection: ASC) {
          user {
            email
            display_name
            first_name
            last_name
            organisation_role
          }
          series_id
          attendance_type
          number_of_occurences
          created_by
          event_id
          event_title
          start_time
          end_time
          facilitator
          rsvp
          attendance
          created_at
        }
      }
    }
  }
}
    `;

/**
 * __useRecurringExportEventInviteesQuery__
 *
 * To run a query within a React component, call `useRecurringExportEventInviteesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecurringExportEventInviteesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecurringExportEventInviteesQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useRecurringExportEventInviteesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<RecurringExportEventInviteesQuery, RecurringExportEventInviteesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RecurringExportEventInviteesQuery, RecurringExportEventInviteesQueryVariables>(RecurringExportEventInviteesDocument, options);
      }
export function useRecurringExportEventInviteesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RecurringExportEventInviteesQuery, RecurringExportEventInviteesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RecurringExportEventInviteesQuery, RecurringExportEventInviteesQueryVariables>(RecurringExportEventInviteesDocument, options);
        }
export type RecurringExportEventInviteesQueryHookResult = ReturnType<typeof useRecurringExportEventInviteesQuery>;
export type RecurringExportEventInviteesLazyQueryHookResult = ReturnType<typeof useRecurringExportEventInviteesLazyQuery>;
export type RecurringExportEventInviteesQueryResult = Apollo.QueryResult<RecurringExportEventInviteesQuery, RecurringExportEventInviteesQueryVariables>;